



































import { defineComponent, computed, toRefs } from '@vue/composition-api';

const name = 'ttam-ad-list-item-operate-buttons';

export default defineComponent({
  name,

  props: {
    disabled: { type: Boolean, default: false },
    disabledHint: { type: String, default: '' },
    copyLoading: { type: Boolean, default: false },
    isCopyButtonVisible: { type: Boolean, default: true },
    isCopyButtonLoading: { type: Boolean, default: false },
  },

  setup(props, { emit }) {
    const { disabled, copyLoading } = toRefs(props);
    const disabledCopy = computed(() => disabled.value || copyLoading.value);

    function copyClick() {
      if (disabledCopy.value) {
        return;
      }
      emit('copy');
    }

    function deleteClick() {
      if (disabled.value) {
        return;
      }
      emit('delete');
    }

    return {
      disabledCopy,
      copyClick,
      deleteClick,
    };
  },
});
